export const valoresExibidosOffCanvasOrgInters: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  statusOrgInter: 'Status',
  componenteAf: 'Componente',
  orgNome: 'Organização',
  orgSigla: 'Sigla',
  nupGeral: 'NUP Geral',
  nupEspecifico: 'NUP Específico',
  nProdutos: 'Nº de Produtos',
  valorTotal: 'Valor Total R$',
};

export const headersOrgInters = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 5, key: 'id' },
  { text: 'Status', width: 12, key: 'statusOrgInter' },
  { text: 'Componente', width: 12, key: 'componenteAf' },
  { text: 'Org. Internacional', width: 15, key: 'orgSigla' },
  { text: 'NUP Específico', width: 20, key: 'nupEspecifico' },
  { text: 'N Produtos', width: 10, key: 'nProdutos' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const fieldObjectOrgInters = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
